'use client';

import { useEffect } from 'react';

interface SectionAnchorSystemProps {
  sections: string[];
  headerOffset?: number;
}

const SectionAnchorSystem = ({
  sections,
  headerOffset = 80,
}: SectionAnchorSystemProps) => {
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash && sections.includes(hash)) {
        const element = document.getElementById(hash);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      }
    };

    window.addEventListener('hashchange', handleHashChange);
    
    if (window.location.hash) {
      setTimeout(handleHashChange, 100);
    }

    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [sections, headerOffset]);

  return (
    <>
      {sections.map((sectionId) => (
        <div data-component-id="src/components/common/SectionAnchorSystem.tsx:45:8" data-component-path="src/components/common/SectionAnchorSystem.tsx" data-component-line="45" data-component-end-line="50" data-component-file="SectionAnchorSystem.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22%5Bvar%3AsectionId%5D%22%2C%22className%22%3A%22scroll-mt-20%22%7D"
          key={sectionId}
          id={sectionId}
          className="scroll-mt-20"
          style={{ scrollMarginTop: `${headerOffset}px` }}
        />
      ))}
    </>
  );
};

export default SectionAnchorSystem;